import { isNumber } from "lodash";

import { ConstantFormat, DateFns } from "../../../../../../../utils/DateFns";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model, dateFns?: DateFns): string => {
	if (!item || !dateFns) return "";

	const executorArrivalTimestamp =
		item?.executorToOrder?.[0]?.additionalFields?.arrivalTime ||
		item?.additionalFields?.transfer?.lastReceivedOrder
			?.executorToOrder?.[0]?.additionalFields?.arrivalTime;

	if (!isNumber(executorArrivalTimestamp)) return "";

	const time =
		item?.orderDate ||
		item?.filledAt ||
		item?.additionalFields?.transfer?.lastReceivedOrder?.filledAt ||
		item?.additionalFields?.transfer?.lastReceivedOrder?.orderDate ||
		1;

	const orderTime = dateFns.toZonedTime(time).getTime();
	const value = Math.max(
		orderTime,
		dateFns.toZonedTime(executorArrivalTimestamp).getTime(),
	);

	return dateFns.formatTime(value, {
		formatTime: ConstantFormat.HMS_UK,
		isZeroSeconds: true,
	});
};

export default cellProcessing;
